import { FREventAssignmentPage } from '../fr-event-assignment/fr-event-assignment-page';
import { useUnitAssignment } from '../unit-assignment/unit-assignment-context';
import { FrEditUnitPage } from '../fr-edit-unit-page/fr-edit-unit-page';
import { useAutoNavigateToEvent } from '../fr-navigation/hooks/use-auto-navigate-to-event';

export function FrHomepage() {
    const unitAssignment = useUnitAssignment();
    useAutoNavigateToEvent();

    if (!unitAssignment?.unitId) {
        return <FrEditUnitPage />;
    }

    if (!unitAssignment?.assignedEvent) {
        return <FREventAssignmentPage />;
    }

    return null;
}
